import { type FunctionalComponent, h } from '@stencil/core'
import type { TrackingState } from '../utils/storage'

interface TrackingPanelProps {
  trackingState: TrackingState
  urlParams: string
  onTrackingChange: (field: keyof TrackingState, value: string) => void
  onApplyTracking: () => void
  onClearTracking: () => void
  onSetRandomTracking: () => void
}

export const TrackingPanel: FunctionalComponent<TrackingPanelProps> = ({ trackingState, urlParams, onTrackingChange, onApplyTracking, onClearTracking, onSetRandomTracking }) => (
  <div class="debug-toolbar-panel open">
    <div class="debug-toolbar-header">
      <h3>Tracking Debug</h3>
    </div>
    <div class="debug-toolbar-section">
      <div class="debug-toolbar-control">
        <label htmlFor="debugClickId">Click ID (gclid, fbclid)</label>
        <input
          value={trackingState.clickId}
          type="text"
          id="debugClickId"
          placeholder="e.g., gclid=abc123"
          onInput={e => onTrackingChange('clickId', (e.target as HTMLInputElement).value)}
        />
      </div>
      <div class="debug-toolbar-control">
        <label htmlFor="debugReferrer">Referrer Override</label>
        <input
          value={trackingState.referrer}
          type="text"
          id="debugReferrer"
          placeholder="https://example.com"
          onInput={e => onTrackingChange('referrer', (e.target as HTMLInputElement).value)}
        />
      </div>
      <div class="debug-toolbar-control">
        <label htmlFor="debugCustomParam">Custom Tracking Param</label>
        <input
          value={trackingState.customParam}
          type="text"
          id="debugCustomParam"
          placeholder="utm_source=test"
          onInput={e => onTrackingChange('customParam', (e.target as HTMLInputElement).value)}
        />
      </div>
      <div class="debug-toolbar-control">
        <div class="debug-toolbar-button-group">
          <button
            class="debug-toolbar-button"
            type="button"
            onClick={onApplyTracking}
          >
            Apply
          </button>
          <button
            class="debug-toolbar-button secondary"
            type="button"
            onClick={onClearTracking}
          >
            Clear
          </button>
          <button
            class="debug-toolbar-button secondary"
            type="button"
            onClick={onSetRandomTracking}
          >
            Set random
          </button>
        </div>
      </div>
      <div class="debug-toolbar-info">
        <strong>Current URL Params:</strong>
        <br />
        <code>{urlParams}</code>
      </div>
    </div>
  </div>
)
